/** @format */

import React from "react";
import { Col, Container, Row } from "reactstrap";
import LoginForm from "../Common/LoginForm";
import { dynamicImage } from "../../../../../Utils";

export default function VisualLogin2() {
  return (
    <Container fluid>
      <Row>
        {/* Decorative circles */}
        <div className="absolute top-20 right-20">
          <div className="relative">
            {/* Outer blue circle with white shadow */}
            <div className="w-32 h-32 rounded-full bg-blue-400/30 shadow-lg" />
            {/* Inner white circle for shadow effect */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-24 h-24 rounded-full bg-white/40 blur-sm" />
            {/* Glowing green circle */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 rounded-full bg-green-400/30 animate-pulse shadow-[0_0_15px_rgba(52,211,153,0.5)]" />
          </div>
        </div>

        {/* Small circle in bottom left */}
        <div className="absolute bottom-20 left-20">
          <div className="relative">
            <div className="w-24 h-24 rounded-full bg-blue-400/30 shadow-lg" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 rounded-full bg-white/40 blur-sm" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-14 h-14 rounded-full bg-green-400/30 animate-pulse shadow-[0_0_15px_rgba(52,211,153,0.5)]" />
          </div>
        </div>

        {/* Main content */}
        <Col
          xl={5}
          className="p-0 d-flex align-items-center justify-content-center flex-column text-container relative z-10"
          style={{
            background:
              "linear-gradient(to bottom right, #95cefe, #eff9ff, #eff9ff)",
            minHeight: "100vh",
          }}>
          <h1 className="mb-3 text-4xl md:text-5xl lg:text-6xl font-bold">
            Grow your Business with
          </h1>
          <img
            src="../../../../../assets/images/Tealbo_logo.png"
            alt="Logo"
            className="business-logo"
            style={{ width: "450px", height: "auto" }}
          />
        </Col>

        <Col xl={7} className="p-0">
          <div
            className="login-card login-dark d-flex align-items-center justify-content-center"
            style={{ minHeight: "100vh" }}>
            <LoginForm logoClass="text-start" />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
